import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface AvatarProps {
  bgColor?: string;
  className?: string;
  children?: React.ReactNode;
}

/**
 * A component that displays a simple circle with the text inside.
 */
export const Avatar: FC<AvatarProps> = ({ className, bgColor, children }) => {
  return (
    <div
      className={twMerge(
        "flex size-9 items-center justify-center rounded-full text-base font-semibold shadow-md",
        className,
      )}
      style={bgColor ? { backgroundColor: bgColor } : undefined}
    >
      {children}
    </div>
  );
};
